import { useParams } from "react-router-dom"


import phenom_icon1 from "../../../../assets/case_study/phenom_icon1_section6.svg"
import phenom_icon4 from "../../../../assets/case_study/phenom_icon4_section6.svg"
import phenom_icon5 from "../../../../assets/case_study/phenom_icon5_section6.svg"
import phenom_icon6 from "../../../../assets/case_study/phenom_icon6_section6.svg"

import incuspaze_icon1 from "../../../../assets/case_study/incuspaze_icon1_section6.svg"
import incuspaze_icon2 from "../../../../assets/case_study/incuspaze_icon2_section6.svg"
import incuspaze_icon3 from "../../../../assets/case_study/incuspaze_icon3_section6.svg"
import incuspaze_icon4 from "../../../../assets/case_study/incuspaze_icon4_section6.svg"
import incuspaze_icon5 from "../../../../assets/case_study/incuspaze_icon5_section6.svg"

import monitra_icon1 from "../../../../assets/case_study/monitra_icon1_section6.svg"
import monitra_icon2 from "../../../../assets/case_study/monitra_icon2_section6.svg"
import monitra_icon3 from "../../../../assets/case_study/monitra_icon3_section6.svg"
import monitra_icon4 from "../../../../assets/case_study/monitra_icon4_section6.svg"
import monitra_icon5 from "../../../../assets/case_study/monitra_icon5_section6.svg"
import monitra_icon6 from "../../../../assets/case_study/monitra_icon6_section6.svg"

import goken_icon1 from "../../../../assets/case_study/goken_icon1_section6.svg"
import goken_icon2 from "../../../../assets/case_study/goken_icon2_section6.svg"
import goken_icon3 from "../../../../assets/case_study/goken_icon3_section6.svg"
import goken_icon4 from "../../../../assets/case_study/goken_icon4_section6.svg"
import goken_icon5 from "../../../../assets/case_study/goken_icon5_section6.svg"
import goken_icon6 from "../../../../assets/case_study/goken_icon6_section6.svg"
import goken_icon7 from "../../../../assets/case_study/goken_icon7_section6.svg"

import ikf_icon1 from "../../../../assets/case_study/ikf_icon1_section6.svg"
import ikf_icon2 from "../../../../assets/case_study/ikf_icon2_section6.svg"
import ikf_icon3 from "../../../../assets/case_study/ikf_icon3_section6.svg"
import ikf_icon4 from "../../../../assets/case_study/ikf_icon4_section6.svg"
import ikf_icon5 from "../../../../assets/case_study/ikf_icon5_section6.svg"

const CaseStudySection6 = {
    phenom: {
        content1: "80% reduction in HR workload due to automated workflows and candidate-led verification.",
        content2: "<1% amber reports (i.e., cases with missing or inconclusive data), a new benchmark in report accuracy.",
        content3: "Turnaround time reduced by over 70%, with most reports completed in <72 hours.",
        content4: "Highest level of transparency across all stakeholders with live dashboards and clear audit trails.",
        content5: "Support resolution time dropped from days to hours, improving HR agility.",
        content6: "End-to-end HR portal integration via API, enabling a single-source view and effortless tracking.",
        icon_1: phenom_icon1,
        icon_2: incuspaze_icon5,
        icon_3: incuspaze_icon3,
        icon_4: phenom_icon4,
        icon_5: phenom_icon5,
        icon_6: phenom_icon6,
    },
    goken: {
        content1: "Eliminated Manual Processes: Transitioned to 100% paperless, self-service verification — reducing HR workload drastically.",
        content2: "Faster Hiring Cycles: TAT was reduced to under 5 days, accelerating onboarding.",
        content3: "Higher Candidate Participation: The multilingual, mobile-first portal significantly improved completion rates among regional and blue-collar candidates.",
        content4: "Streamlined HR Operations: A single platform for all employee categories made day-to-day HR functions more efficient and organized.",
        content5: "Reduced Support Overhead: Fewer support requests and candidate drop-offs allowed the HR team to focus on strategic priorities.",
        content6: "Stronger Compliance & Transparency: Blockchain-backed reports provided a robust and trustworthy audit trail.",
        content7: "<1-Hour Support SLA: Hirestar.io’s customer success team consistently delivered fast, proactive assistance, creating a strong trust factor.",
        icon_1: goken_icon1,
        icon_2: goken_icon2,
        icon_3: goken_icon3,
        icon_4: goken_icon4,
        icon_5: goken_icon5,
        icon_6: goken_icon6,
        icon_7: goken_icon7
    },
    ikf: {
        content1: "75% faster onboarding — average TAT dropped from 12 to under 5 days",
        content2: "90% less HR follow-up — thanks to self-serve portals and ops team handling",
        content3: "250+ checks covered, customizable as per IKF’s role and region",
        content4: "Audit-ready verification with blockchain-backed, tamper-proof records",
        content5: "First-time use of AI in their BGV process, boosting fraud detection and decision confidence",
        icon_1: ikf_icon1,
        icon_2: ikf_icon2,
        icon_3: ikf_icon3,
        icon_4: ikf_icon4,
        icon_5: ikf_icon5,
    },
    monitra: {
        content1: "60% reduction in onboarding time for nurses and doctors",
        content2: "100% adoption of mobile-first BGV, even in rural/remote deployments",
        content3: "Zero language-related verification issues, thanks to the Telugu-enabled flow",
        content4: "End-to-end automation, eliminating HR dependencies in the verification loop",
        content5: "Medical screening integrated, removing the need for external health vendors",
        content6: "Positive employee experience, with transparent, secure, and fast verification",
        icon_1: monitra_icon1,
        icon_2: monitra_icon2,
        icon_3: monitra_icon3,
        icon_4: monitra_icon4,
        icon_5: monitra_icon5,
        icon_6: monitra_icon6,
    },
    incuspaze: {
        content1: "100% elimination of manual forms through a self-verification workflow for visitors and candidates.",
        content2: "Company entity verification suite fully automated, reducing legal and compliance overhead.",
        content3: "Turnaround time improved by over 65%, enabling faster onboarding and real-time visitor verification.",
        content4: "Consistent sub-hour support response time from Hirestar.io — a major shift from the slow service previously experienced.",
        content5: "Structured, easy-to-interpret reports replaced chaotic vendor deliverables.",
        icon_1: incuspaze_icon1,
        icon_2: incuspaze_icon2,
        icon_3: incuspaze_icon3,
        icon_4: incuspaze_icon4,
        icon_5: incuspaze_icon5,
    },
}


export default function PhenomCaseStudySection6() {
    const { companyName } = useParams();
    const companyData = CaseStudySection6[companyName];

    if (!companyData) {
        return (
            <section className="py-12 text-center">
                <h2 className="text-[28px] md:text-[36px] font-semibold mb-4">
                    No Data Found
                </h2>
                <p className="text-gray-600">The specified company case study does not exist.</p>
            </section>
        );
    }

    // Collect content and icon keys in order
    const contents = Object.keys(companyData)
        .filter((key) => key.startsWith("content"))
        .sort() // content1, content2...
        .map((key) => companyData[key]);

    const icons = Object.keys(companyData)
        .filter((key) => key.startsWith("icon_"))
        .sort((a, b) => {
            // Ensures icon_10 comes after icon_2
            const numA = parseInt(a.split("_")[1], 10);
            const numB = parseInt(b.split("_")[1], 10);
            return numA - numB;
        })
        .map((key) => companyData[key]);

    return (
        <section className="mx-4 py-12 flex items-center justify-center">
            <div className="max-w-6xl w-full text-center">
                {/* Heading */}
                <h2 className="text-[28px] md:text-[36px] font-semibold mb-10">
                    The Outcome
                </h2>

                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mx-auto">
                    {contents.map((text, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-xl shadow-md p-6 flex items-start gap-4 ${contents.length % 2 !== 0 && index === contents.length - 1
                                    ? "md:col-span-2 justify-center mx-auto max-w-2xl"
                                    : ""
                                }`}
                        >
                            <img
                                src={icons[index]}
                                alt={`Outcome icon ${index + 1}`}
                                width={70}
                                height={70}
                                className="flex-shrink-0"
                            />

                            <p className="text-[16px] md:text-[18px] text-left">{text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
